export function shouldShowRecordingClip(startTime, endTime, callDurationInSeconds) {
  // If there is no end time then it's not a clip
  if (endTime === null) {
    return false;
  }

  // CallDurationInSeconds is a precise, non-integer time. But if the endTime is within 1s of the
  // precise duration we can safely assume it's supposed to be the end of the call
  const endTimeToUse = callDurationInSeconds - endTime < 1 ? callDurationInSeconds : endTime;
  return startTime >= 0 && endTime > 0 && endTimeToUse - startTime < callDurationInSeconds && endTimeToUse > startTime;
}

// For a given array of utterances, merge any that are within a certain threshold of each other so pills aren't so compact
export function utterancePillSimplifier({
  pills,
  durationInSeconds,
  proportionalThreshold = 0.003,
  identityProperty = null
}) {
  const result = [];
  if (!pills) return result;
  if (pills.length < 2) return pills;
  const threshold = durationInSeconds * proportionalThreshold;
  let currentExcerpt = Object.assign({}, pills[0]);
  for (let i = 1; i < pills.length; i++) {
    const targetExcerpt = pills[i];

    // For call topics, if it's a different topic, don't merge
    const isNewExcerpt = identityProperty && identityProperty in targetExcerpt && identityProperty in currentExcerpt && targetExcerpt[identityProperty] !== currentExcerpt[identityProperty];

    // Merge if within threshold, otherwise just add it as a new excerpt to the return array
    if (!isNewExcerpt && pills[i].startTimeSeconds - currentExcerpt.endTimeSeconds < threshold) {
      currentExcerpt.endTimeSeconds = pills[i].endTimeSeconds;
    } else {
      result.push(currentExcerpt);
      currentExcerpt = Object.assign({}, pills[i]);
    }
  }
  result.push(currentExcerpt);
  return result;
}

// Function is responsible for filtering out utterances which have invalid start time and updating the end time to duration if (endTime > duration of call)
export function filterUtterancesWithValidDuration(utterances, durationInSeconds) {
  const filteredUtterances = utterances.filter(utterance => utterance.startTimeSeconds < durationInSeconds);
  return filteredUtterances.map(utterance => {
    if (utterance.endTimeSeconds > durationInSeconds) {
      return Object.assign({}, utterance, {
        endTimeSeconds: durationInSeconds
      });
    }
    return Object.assign({}, utterance);
  });
}
export function getLocationAndWidth(startTime, endTime, duration, isPill = false) {
  const startLoc = startTime / duration * 100;
  let width;
  if (isPill) {
    if (endTime !== null) {
      width = (endTime - startTime) / duration * 100;
    } else {
      throw new Error('endTime must be defined when isPill is true');
    }
  } else {
    width = duration - startTime < 1 ? 100 : startTime / duration * 100;
  }
  return {
    startLoc,
    width
  };
}